/* eslint-disable no-debugger */
import { AxiosResponse } from "axios";

import { IPaginatedResponse } from "../@types/PaginatedResponse";
import { api } from "./api";

export const journalService = {
  async getJournals(patientId: number): Promise<AxiosResponse> {
    const url = "/Portal/Journals";

    const urlParamsParsed = new URLSearchParams();

    urlParamsParsed.append("patientId", patientId.toString());

    const journalsResponse = await api.get<IPaginatedResponse<any>>(url, {
      params: urlParamsParsed,
    });
    return journalsResponse;
  },

  async getJournalsPaginated(
    patientId: number,
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Journals";

    const params: Record<string, string | number> = {
      patientId,
    };

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }

    return api.get<IPaginatedResponse<any>>(url, { params });
  },

  async getJournalById(id: number): Promise<AxiosResponse> {
    const url = `/Portal/Journals/${id}`;
    const journal = await api.get(url);
    return journal;
  },
};
